const { version } = require("../../../package.json");
export default {
	call: (apiName, ...params) => {
		if (window.beidouInstance && window.beidouInstance[apiName]) {
			window.beidouInstance[apiName].apply(
				window.beidouInstance[apiName],
				params
			);
		}
	},
	init: () => {
		if (typeof window === "undefined") {
			return false;
		}
		const beidouScript = document.querySelector("#beidouScript");
		if (!beidouScript) {
			var spt = document.createElement("script");
			spt.src = "//res.huizecdn.com/beidou-js-sdk-v2/index.v2.min.js";
			spt.id = "#beidouScript";
			var sNode = document.getElementsByTagName("script")[0];
			sNode.parentNode.insertBefore(spt, sNode);
			spt.onload = () => {
				const beidouInstance = window.BeidouInject.init({
					app_id: "73043a72f3e34f70a7b44da42640dd56",
					app_version: version,
					// 如果有使用到next.js的内置链接，该选项需要开启用来追踪next.js的单页面应用跳转
					is_track_single_page: true,
					// 下面的一般情况请不要开启，会记录所有的用户行为，上行流量会很大
					heatmap: {
						//是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
						clickmap: "default",
						//是否开启触达注意力图，默认 not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启
						scroll_notice_map: "default",
					},
				});
				window.beidouInstance = beidouInstance;
				beidouInstance.quick("autoTrack");
			};
		} else {
			console.info("beidou sdk injected");
		}
	},
};



// WEBPACK FOOTER //
// ./src/utils/beidou/index.js